import React,{Component} from 'react';
import firebase from '../../config'
import { Menu, Dropdown, Button } from 'antd';
import { Form, Input, InputNumber} from 'antd';
import Box from '@material-ui/core/Box'


const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  


export default class Add extends Component{
    constructor(props){
        super(props)
        
        this.state={
          data : {},
          tests :[],
          selected :null,
          visible:false
        }
    }
    get = () =>{
      let res = {};
      return new Promise(resolve => {firebase.firestore().collection('search').get().then(snap =>{
          snap.forEach(doc =>{
            let data = doc.data();
            console.log(data)

            let name = doc.id;
            res[name] = data;
          })
          resolve(res)
        })
        
      })
    }
    componentDidMount(){
      this.get().then(res =>{
      console.log(res)
      this.setState({
        data :res
      },console.log(res))
    })
    }


   
    handleSubmit = (values)=>{
        var obj ={}
        var tests = this.state.tests;
        var all = this.state.data;
        tests.forEach(data =>{
          obj[data] =  all[data];
        })
        values.tests = obj
        console.log(values);
        const db = firebase.firestore();
        let ref  =  db.collection('packages').add(values).then(() =>{
            alert("Added sucessfully")
        })
    }
    util = (e) =>{
      var tests = [...this.state.tests]
      tests.push(e.key)
      this.setState({
        tests:tests
      },()=>console.log(this.state))
      
    }
    testMenu = () =>{
    var key =Object.keys(this.state.data);
     return <Menu onClick={this.util}>
       {
         key.map(el =>{
          return <Menu.Item key={el}>{el}</Menu.Item>
         })
       }

     </Menu>
    }
    selected =() =>{
      var tests =  this.state.tests;
      return <div>
        <Box>Selected</Box>
        {
          tests.map(e =>{
            return <h6>{e}</h6>
          })
        }
      </div>
    }
    addForm = () =>{
        
                   return (
                <Form {...layout} name="add" onFinish={ this.handleSubmit} >
                <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item  label="Price" name="price" rules={[{ required:true }]}>
                  <Input />
                </Form.Item>
                <Form.Item  label="Report Days" name="report_days" rules={[{ type: 'number',required:true,min: 0, max: 99 }]}>
                  <InputNumber />
                </Form.Item>
                <Form.Item label="overview" name="overview" >
                  <Input />
                </Form.Item>
                <Form.Item  label="details" name="details">
                  <Input.TextArea />
                </Form.Item>
                <Box display="flex">

              
                </Box>

                <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            )

    }
    render(){
      var res =[]
      var selected = this.state.selected
        return(
            <div>
                <Box display="flex" justifyContent="space-between" flexDirection="column">
                  <Box textAlign="center" fontFamily="monospace" fontWeight="bold" fontSize="1.1em"> Add Package</Box>

                    <Box justifyContent="flex-start">
                        <this.addForm></this.addForm>
                        <Dropdown trigger="click" overlay={this.testMenu}>
                           <Button color="primary">{this.state.selected===null ? "select test" : this.state.selected}</Button>
                        </Dropdown>

                    </Box>
                    <this.selected/>

                </Box>


               
            </div>
        )
    }
}